module.exports = __webpack_public_path__ + "static/card-actions-do-7fa89297e7690acd66e968ddf92ccd17.png";